export default function dialogContentText({ typography, colors }) {
  const { size } = typography;
  const { text } = colors;

  const dialogContentText = {
    styleOverrides: {
      root: {
        fontSize: size.md,
        color: text.main,
      },
    },
  };

  return dialogContentText;
}
